@if (isOpen() && announcement; as card) {
  <div
    class="fixed bottom-6 left-[100px] z-40 w-[380px] overflow-hidden rounded-2xl border-1 border-solid border-ex-solid-basic-300 bg-white shadow-[0_12px_40px_rgba(20,30,60,0.18)] [animation:announcement-in_.35s_ease-out]"
    role="dialog"
    aria-label="Annonce du webinaire"
  >
    <div class="relative">
      <img [src]="card.image" [srcset]="card.imageSrcset" sizes="380px" [alt]="card.imageAlt" class="block aspect-[1200/520] w-full" />
      <button
        type="button"
        (click)="close()"
        aria-label="Fermer"
        class="absolute top-3 right-3 flex size-7 cursor-pointer items-center justify-center rounded-full border-0 bg-white/80 text-(--basic-900) shadow-sm hover:bg-white"
      >
        <i class="ph-bold ph-x pointer-events-none text-[13px]" aria-hidden="true"></i>
      </button>
    </div>
    <div class="flex flex-col gap-[12px] px-[20px] pt-[16px] pb-[20px]">
      <div class="flex flex-col gap-2">
        <div class="flex items-center justify-between gap-2">
          <span
            class="inline-flex items-center gap-1.5 text-[11px] whitespace-nowrap font-bold tracking-[0.06em] text-(--primary-500) uppercase"
          >
            <i class="ph-fill ph-broadcast text-[13px]" aria-hidden="true"></i>{{ card.eyebrow }}
          </span>
          <span
            class="inline-flex items-center gap-1 shrink-0 rounded-full bg-(--primary-500) px-[10px] py-[4px] whitespace-nowrap text-[12px] font-bold text-white"
          >
            <i class="ph-bold ph-calendar-blank text-[12px]" aria-hidden="true"></i>{{ card.dateLabel }}
          </span>
        </div>
        <p class="m-0 text-[14px] leading-relaxed text-ex-solid-basic-900">{{ card.text }}</p>
      </div>
      <a
        [href]="card.url"
        target="_blank"
        rel="noopener"
        (click)="register()"
        class="flex h-10 items-center justify-center rounded-lg bg-(--basic-900) text-[14px] font-semibold text-(--basic-100) no-underline shadow-(--box-shadow) hover:bg-(--basic-950) hover:text-(--basic-100)"
        >{{ card.cta }}</a
      >
    </div>
  </div>
}
